import React, { Component } from 'react';
import { PanelBar, PanelBarUtils, PanelBarItem } from "@progress/kendo-react-layout";
import "./panelBarGL-pure.css";

/**
 * @typedef {object} Props
 * @property {JSX.Element} children - Contenido a renderizar dentro del PanelBarGLPure
 * @property {string} titlePanel - Título del panel
 * @property {boolean} expandedPanel - Indica si el panel está expandido o colapsado
 * @property {string} id - ID único para el componente
 * @property {JSX.Element} [actionComponent] - Componente adicional para acciones en el encabezado del panel (opcional)
 * @property {string} [className] - Clase CSS adicional para personalización (opcional)
 */

/**
 * @param {Props} props
 * @return {*} 
 */
const PanelBarGLPure = (props) => {
    const {
        children,
        titlePanel,
        expandedPanel,
        id,
        actionComponent
    } = props

    const panelHeader = (
        <div className='panelBarGLPure-header'>
            <span>{titlePanel}</span>
            {actionComponent && (
                <div
                    onClick={(e) => e.stopPropagation()}
                >
                    {actionComponent}
                </div>
            )}
        </div>
    )

    return (
        <div className='panelBarGLPure-wrapper' id={id}>
            <PanelBar>
                <PanelBarItem expanded={expandedPanel} title={panelHeader} className='panelBarGLPure-items'>
                    <div className='panelBarGLPure-container-children'>
                        {children}
                    </div>
                </PanelBarItem>
            </PanelBar>
        </div>
    )
}

export default PanelBarGLPure